import React, { useEffect } from "react";
import { useNavigate } from "fusion-plugin-react-router";
import { downloadPrivacyPolicy } from "../shared/utils/apiUtils";

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    downloadPrivacyPolicy({ navigate });
    // Redirect back after a short delay to ensure download starts
    const timer = setTimeout(() => {
      navigate(-1); // Go back to previous page
    }, 1000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return null; // No UI needed
};

export default PrivacyPolicyPage;
